import React, { useEffect, useState } from "react";
import tmsRouteMap from "../../../../constants/tms-route.map";
import TmsTabsLayout from "../../../../components/tms-customs/tms-tabs-layout";
import { withRouter } from "../../../../utils/tms-with-router/tms-with-router";
import TmsReportPrasadamReport from "./tms-report-prasadam-report";
import TmsReportPrasadamSummaryReport from "./tms-report-prasadam-summary-report";
const TmsReportPrasadam = ({ router }) => {
  const [active, setActive] = useState("Users");

  useEffect(() => {
    let location = router?.location?.pathname;
    if (location === tmsRouteMap.reports_prasadam) {
      setActive("Prasadam Report");
      return;
    } else if (location.includes(tmsRouteMap.reports_prasadam_summary_report)) {
      setActive("Summary Report");
    }
  }, [router?.location?.pathname]);

  const components = [
    {
      name: "Prasadam Report",
      Element: <TmsReportPrasadamReport />,
      key: "Prasadam Report",
      route: tmsRouteMap.reports_prasadam,
    },

    {
      name: "Summary Report",
      Element: <TmsReportPrasadamSummaryReport />,
      key: "Summary Report",
      route: tmsRouteMap.reports_prasadam_summary_report,
    },
  ];

  return (
    <div style={{ width: "100%", height: "100%" }}>
      <TmsTabsLayout
        components={components}
        active={active}
        setActive={setActive}
      />
    </div>
  );
};
export default withRouter(TmsReportPrasadam);
